import React, { useState } from 'react';
import { Box, IconButton, MobileStepper, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

interface AnimalPhotoCarouselProps {
  photos: string[];
  onClose: () => void;
}

const AnimalPhotoCarousel = ({ photos, onClose }: AnimalPhotoCarouselProps) => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = photos.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
  };

  return (
    <Box sx={{ 
      position: 'relative', 
      width: '100%', 
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: 'background.paper',
      borderRadius: 1,
      overflow: 'hidden',
    }}>
      <Box sx={{ 
        position: 'absolute', 
        top: 8, 
        right: 8, 
        zIndex: 10 
      }}>
        <IconButton onClick={onClose} color="primary">
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ 
        height: 'calc(100% - 48px)', 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        position: 'relative',
      }}>
        {photos.length > 0 && (
          <Box
            component="img"
            sx={{
              maxHeight: '100%',
              maxWidth: '100%',
              objectFit: 'contain',
              borderRadius: 1,
            }}
            src={photos[activeStep]}
            alt={`Animal photo ${activeStep + 1}`}
          />
        )}

        {photos.length > 1 && (
          <>
            <IconButton
              sx={{
                position: 'absolute',
                left: 16,
                bgcolor: 'rgba(255, 255, 255, 0.7)',
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.9)' },
              }}
              onClick={handleBack}
            >
              <NavigateBeforeIcon />
            </IconButton>
            <IconButton
              sx={{
                position: 'absolute',
                right: 16,
                bgcolor: 'rgba(255, 255, 255, 0.7)',
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.9)' },
              }}
              onClick={handleNext}
            >
              <NavigateNextIcon />
            </IconButton>
          </>
        )}
      </Box>

      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        sx={{ bgcolor: 'background.paper' }}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={photos.length <= 1}
          >
            Next
            <NavigateNextIcon />
          </Button>
        }
        backButton={
          <Button 
            size="small" 
            onClick={handleBack}
            disabled={photos.length <= 1}
          >
            <NavigateBeforeIcon />
            Back
          </Button>
        }
      />
    </Box>
  );
};

export default AnimalPhotoCarousel;
